// Single source of truth for the version lifecycle milestone fields — shared
// by the progress cell (data-table-column) and the release timeline
// (column-publish-log).

export const VERSION_MILESTONES = [
  { field: "devStartAt", label: "Dev start" },
  { field: "devFinishAt", label: "Dev finish" },
  { field: "testStartAt", label: "Test start" },
  { field: "testFinishAt", label: "Test finish" },
  { field: "onlineAt", label: "Online" },
] as const;

export type MilestoneField = (typeof VERSION_MILESTONES)[number]["field"];
